export default "__VITE_ASSET__DdZtBQAg__"